import { useNavigate } from 'react-router-dom';
import { useMemo, useState } from 'react';
import { SlidingBanner } from '../../interfaces/SlidingBanner/SlidingBanner';
import { TableColumn } from '../../components/DataTable/TableColumn';
import { TextColumn } from '../../components/DataTable/TextColumn';
import { BoolColumn } from '../../components/DataTable/BoolColumn';
import { DateColumn } from '../../components/DataTable/DateColumn';
import { paginateRows } from '../../utils/Pagination';
import { DataTable } from '../../components/DataTable/DataTable';

const columns: TableColumn<SlidingBanner>[] = [
  {
    id: 'id',
    name: 'ID',
    accessor: (row) => <TextColumn value={row.id.toString()} />,
  },
  {
    id: 'title',
    name: 'İsim',
    accessor: (row) => <TextColumn value={row.title} />,
  },
  {
    id: 'sort-order',
    name: 'Sıra',
    accessor: (row) => <TextColumn value={row.sortOrder.toString()} />,
  },
  {
    id: 'link-url',
    name: 'Link',
    accessor: (row) => <TextColumn value={row.linkUrl} />,
  },
  {
    id: 'is-active',
    name: 'Durum',
    accessor: (row) => <BoolColumn value={row.isActive} />,
    align: 'center',
  },
  {
    id: 'created-at',
    name: 'Oluşturulma Tarihi',
    accessor: (row) => <DateColumn value={row.createdAt} />,
  },
  {
    id: 'updated-at',
    name: 'Düzenlenme Tarihi',
    accessor: (row) => <DateColumn value={row.updatedAt} />,
  },
];

type SlidingBannersTableProps = {
  slidingBanners: SlidingBanner[];
};

export const SlidingBannersTable = (props: SlidingBannersTableProps) => {
  const navigate = useNavigate();

  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);

  const paginatedRows = useMemo(
    () => paginateRows(props.slidingBanners, limit, page),
    [props.slidingBanners, limit, page],
  );

  return (
    <DataTable
      columns={columns}
      totalCount={props.slidingBanners.length}
      rows={paginatedRows}
      limit={limit}
      setLimit={setLimit}
      page={page}
      setPage={setPage}
      onClick={(slidingBanner) =>
        navigate(`/visual/sliding-banners/${slidingBanner.id}`)
      }
    />
  );
};
